export default __webpack_public_path__ + "static/manage-money-digitally-a6f6a720d6187134cb8631fe0c715045.jpg";